import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col } from 'antd';
import { AVALARA_FIELDS } from '../constants';
import { DEFAULT_SERVER_STATUS } from '../constants';

export default function AvalaraSettingsModal({ visible, onCancel, onSave, initialData }) {
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        form.setFieldsValue(initialData);
      } else {
        form.resetFields();
      }
    }
  }, [initialData, form, visible]);

  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values });
    const { success, code } = response;
    setServerResponse({success, code, message: response.message});
    if (success && !response?.message) {
      form.resetFields();
    }
  };

  const onEdit = () => {
    setServerResponse(DEFAULT_SERVER_STATUS);
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={(initialData && initialData.id) ? 'Edit Avalara Settings' : 'Add Avalara Settings'}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        name="avalara_settings"
        layout="vertical"
        onFinish={onFinish}
        >
        <Row gutter={16}>
            {AVALARA_FIELDS.map(field => (
              <Col
                key={field.name}
                xs={24}
                sm={24}
                md={12}
              >
                <Form.Item
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  rules={field.rules}
                >
                  {
                    field.name === 'password' ? <Input.Password onChange={() => {onEdit()}} /> : <Input onChange={() => {onEdit()}} />
                  }
                </Form.Item>
            </Col>
            ))}
        </Row>
        </Form>
        {
          (!serverResponse.status && serverResponse.message) &&
          <div style={{textAlign: 'center'}}>
            <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
          </div>
        }
    </Modal>
  );
}
